import PropTypes from 'prop-types'
import { Trans, useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import Link from '@web-ui-kit/link'

import * as Sc from './PendingTasks.style'
import { useUpdateTaskNotification } from 'hooks/classroom'
import { convertTimeStampToDate, formatClassroomName } from 'utils'
import { ROUTES } from 'routes/paths'
import useCheckCanary from 'hooks/useCheckCanary'

const PendingTasks = ({ clazz, endDate, taskId, title, userId }) => {
  const { push } = useHistory()
  const {
    t,
    i18n: { language },
  } = useTranslation()
  const showNewAlertCenter = useCheckCanary(
    window?.rebranding?.canaryUsers,
    window?.rebranding?.enableAlerteCenter
  )
  const { mutate } = useUpdateTaskNotification(taskId)

  const { id, name, classroom } = clazz || {}
  const date = convertTimeStampToDate({
    language,
    timestamp: endDate,
  })

  const handleOnClickNotification = () => {
    mutate({ taskId, userId })
    push(
      `${ROUTES.CLASSROOMS}/${id}${ROUTES.TASKS}/${taskId}${ROUTES.STUDENT_MAKE_TASK_ACTIVITIES}`
    )
  }
  const formattedDate = date.replace(',', ' -')
  const formattedClassroom = formatClassroomName({ classroom })

  const renderPendingTaskAlert = () => (
    <>
      <Trans
        i18nKey={
          'Tienes pendiente la tarea “{{title}}” de tu clase de {{name}}. Tienes hasta el {{date}} para realizarla.'
        }
      >
        Tienes pendiente la tarea <strong>“{{ title }}”</strong> de tu clase de{' '}
        <strong>
          {{ name }} - {{ formattedClassroom }}.
        </strong>
        <br />
        <br />
        Tienes hasta el <strong>{{ formattedDate }}</strong> para realizarla.
      </Trans>
      <br />
      <br />
      <Link
        dataTestId={`link-view-task-${taskId}`}
        onClick={() => {
          handleOnClickNotification()
        }}
        size='small'
      >
        {t('Ver tarea')}
      </Link>
    </>
  )

  return showNewAlertCenter ? (
    renderPendingTaskAlert()
  ) : (
    <Sc.StyledAlert
      description={renderPendingTaskAlert()}
      key={taskId}
      variant='info'
    />
  )
}

PendingTasks.propTypes = {
  clazz: PropTypes.shape({
    classroom: PropTypes.shape({}),
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  endDate: PropTypes.number.isRequired,
  taskId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
}

export default PendingTasks
